module.exports = __webpack_public_path__ + "img/8-reach-mountain_v8e.044e664f.png";